<template>
    <div class="progress">
        <div :class="getClassProgressBar()" class="progress-bar" role="progressbar" :style="{'width' : porcentagem+'%'}" style="min-width: 40px">{{porcentagem}}%</div>
    </div>
</template>


<script>
    export default{
        props:{
            value:{
                type: Number,
                default: 0
            },
            max:{
                type: Number,
                default: 0
            },
            invertStatus:{
                type: Boolean,
                default: false
            }
        },
        data(){
            return{
                porcentagem: 0,
            }
        },
        methods: {
            getPorcentagem(){
                
                if(this.value > this.max)
                {
                    this.porcentagem = 100
                    return
                } 

                let porcentagem = parseFloat((this.value * 100) / this.max).toFixed(2)
                porcentagem = porcentagem.replaceAll('.00','')
                this.porcentagem = porcentagem

            },
            getClassProgressBar(){
                return {
                    'bg-success' : (!this.invertStatus && this.porcentagem >= 70 ) || (this.invertStatus && this.porcentagem <= 30),
                    'bg-warning': (this.porcentagem > 30 && this.porcentagem < 70),
                    'bg-danger': (!this.invertStatus && this.porcentagem <= 30 ) || (this.invertStatus && this.porcentagem >= 70),
                }
            }
        },
        mounted(){
            this.getPorcentagem()
        },
        watch: {
            value() {
                this.getPorcentagem()
            },
            max() {
                this.getPorcentagem()
            }
        }
        
    }
</script>